import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('@modules/system/system.module').then(m => m.SystemModule)
  },
  {
    path: 'student',
    loadChildren: () => import('@modules/student/student.module').then(m => m.StudentModule)
  },
  {
    path: 'administration',
    loadChildren: () => import('@modules/admin/admin.module').then(m => m.AdminModule)
  },
  { path: '**', redirectTo: 'auth/login', pathMatch: 'full', },
];

@NgModule({
  // 'enabled', ne 'top': dopředu se skáče nahoru, zpět se obnoví předchozí pozice.
  // Bez toho zůstal student po dočtení dlouhého článku scrollnutý dole i na další
  // stránce — a přechodová animace se odehrála mimo viditelnou část.
  // ⚠ `onSameUrlNavigation: 'reload'` je tu kvuli prepnuti firmy: student uz na
  // rozcestniku stoji, takze `navigate(['/student/dashboard'])` by jinak neudelalo nic
  // a v seznamu by zustaly kurzy predchozi firmy az do F5 (EL-2179).
  //
  // Samo o sobe to nic neprepocita — resolvery se pousti podle `runGuardsAndResolvers`,
  // ktere je `'always'` jen tam, kde se to hodi. Ostatni routy se chovaji jako dosud.
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
